// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"45411779","162":"53d0d522","264":"36bbf0f2","404":"6e60920a","482":"8d78abbf","552":"60d34339","591":"a7179915","655":"dab73e24","749":"be61ac87","867":"d6831857","949":"a7599a01"}[chunkId] + ".chunk.js";
};